import { render, staticRenderFns } from "./OmniCardTitle.vue?vue&type=template&id=2e6cec58&"
var script = {}
import style0 from "./OmniCardTitle.vue?vue&type=style&index=0&id=2e6cec58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports